import { PendingQueueState } from './reconcilePending';
import { StoredScheduleBlock } from './StoredScheduleBlock';

/**
 * The pending-persistence state machine's initial (idle) state: nothing pending,
 * nothing queued, rendering pure store truth.
 */
export const initialPendingState = (
  snapshot: StoredScheduleBlock[] | null = null,
): PendingQueueState => ({
  pending: null,
  inFlight: null,
  queue: [],
  known: [],
  lastSnapshot: snapshot,
});
